var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import IconContainer, { IconSVG } from "./IconContainer";
var IconVideoReference = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", null,
                React.createElement("g", { transform: "translate(8.245 10.365) rotate(45)" },
                    React.createElement("path", { d: "M4.3-1.7v4.3h4.3" }),
                    React.createElement("path", { d: "M18.4,5.4c0.8-3.4-1.4-6.9-4.8-7.7c-2.1-0.5-4.4,0.2-5.9,1.7L4.3,2.5" })),
                React.createElement("g", null,
                    React.createElement("line", { x1: "5.2", y1: "2.6", x2: "5.2", y2: "27.2" }),
                    React.createElement("line", { x1: "5.2", y1: "2.6", x2: "24.5", y2: "14.3" }),
                    React.createElement("line", { x1: "24.8", y1: "14.7", x2: "22.7", y2: "16.1" }),
                    React.createElement("line", { x1: "14.9", y1: "21", x2: "5.2", y2: "27.4" }))))));
});
export default IconVideoReference;
//# sourceMappingURL=IconVideoReference.js.map